export default __webpack_public_path__ + "static/media/cover-image.533ae8f6.jpg";